"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAnchorLink = void 0;
const styles_1 = require("@mui/material/styles");
const anchor_link_1 = __importDefault(require("../anchor-link"));
exports.StyledAnchorLink = (0, styles_1.styled)(anchor_link_1.default)({
    minHeight: "32px",
    minWidth: "32px"
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb2R1Y3Qtb3ZlcnZpZXctY2FyZC9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsaURBQThDO0FBQzlDLGlFQUF3QztBQUUzQixRQUFBLGdCQUFnQixHQUFHLElBQUEsZUFBTSxFQUFDLHFCQUFVLENBQUMsQ0FBQztJQUNqRCxTQUFTLEVBQUUsTUFBTTtJQUNqQixRQUFRLEVBQUUsTUFBTTtDQUNqQixDQUFDLENBQUMifQ==